import * as React from 'react';
import type { PopoverContextType } from './Popover.types';

export const PopoverContext = React.createContext<PopoverContextType | null>(
  null
);

export function usePopoverContext() {
  const ctx = React.useContext(PopoverContext);
  if (!ctx) throw new Error('Popover components must be used within <Popover>');
  return ctx;
}
